import React from 'react';
import {Button} from "./FormUI";
import AppointmentService from "../api/services/AppointmentService";
import CalendarView from "../views/CalendarView";
import RootModal from "./RootModal";

export default class Modals {
	/**
	 *
	 * @param appt - Appointment
	 * @param props
	 * @constructor
	 */
	static DeleteAppointmentModal(appt, props = {}) {
		const appointmentId = appt.appointmentId;
		const deleteModal = (
			<div className="delete-app button-modal">
				<div className="modal-caption">Are you sure you want to delete this appointment?</div>
				<div className="table hmax layout-fixed button-bar">
					<div>
						<div>
							<Button className="red" caption="Yes" onClick={() => {
								let appSer = new AppointmentService();
								appSer.delete(appointmentId).then((d) => {
									CalendarView.Refresh();
									if (props.onSave) {
										props.onSave(d);
									}
								})

								RootModal.CloseModal();
							}}/>
						</div>
						<div>
							<Button caption="No" onClick={() => {
								RootModal.CloseModal()
							}}/>
						</div>
					</div>
				</div>
			</div>
		)

		const deleteSeriesModal = (

			<div className="delete-app series button-modal ">
				<div className="modal-caption">This is a recurring Appointment.<br/> Would you like to delete to all future recurrences of this appointment,
					or this appointment only?
				</div>

				<div className="button-bar">

					<Button className="red" caption="All" onClick={() => {
						let appSer = new AppointmentService();
						appSer.delete(appointmentId, 'all').then((d) => {
							CalendarView.Refresh();
							if (props.onSave) {
								props.onSave(d);
							}
						})

						RootModal.CloseModal();
					}}/>

					<Button caption="This Appointment Only" onClick={() => {
						let appSer = new AppointmentService();
						appSer.delete(appointmentId, 'single').then((d) => {
							CalendarView.Refresh();
							if (props.onSave) {
								props.onSave(d);
							}
						})
						RootModal.CloseModal()
					}}/>

					<Button caption="Cancel" onClick={() => {
						RootModal.CloseModal()
					}}/>

				</div>
			</div>
		)

		const isRecurring = appt['seriesGuid'];

		return RootModal.ShowModal(isRecurring ? deleteSeriesModal : deleteModal);
	}
}



// WEBPACK FOOTER //
// ./src/components/Modals.js